import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  CancelOrdersMutation,
  CancelOrdersMutationVariables,
} from "../generated/graphql";

const CANCEL_ORDERS_MUTATION = gql`
  mutation cancelOrders($input: CancelOrdersInput!) {
    cancelOrders(input: $input) {
      ok
      err
    }
  }
`;

export const useCancelOrders = (
  onCompleted?: (data: CancelOrdersMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CancelOrdersMutation, CancelOrdersMutationVariables>(
    CANCEL_ORDERS_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
